import React, {Component} from 'react';
import Header from "../components/Header";
import strings from "../screenLocalisation/login";
import {connectedSelector, fetchingSelector, rejectedErrorSelector,userSelector} from "../redux/reducers/authReducer";
import {connect} from "react-redux";
import {login} from "../redux/actionCreators/auth";
import {PulseLoader} from "react-spinners";
import {dk_blue, dk_light_gray} from "../constants/style";
import {NavLink} from "react-router-dom";
import ForgotPasswordForm from "../components/ForgotPasswordForm"

class Login extends Component {
    constructor(props){
        super(props)
        this.state = {
            email: '',
            password: '',
            forgotPassword: false,
            errorConnexion: false
        }
    }
    render() {
        let rejections = this.props.rejectedError?this.props.rejectedError:{}
        return (
            <div style={styles.container}>
                <img alt='' style={styles.background} src={require('../assets/img/background.PNG')} />
                <img alt="" style={styles.logo} src={require('../assets/img/logo_blue.png')} />


                <div>
                    {/*<div style={styles.topButtons}>*/}
                        {/*<NavLink style={styles.topButtonInactive} to={'/register'}>*/}
                            {/*{strings.registerButton}*/}
                        {/*</NavLink>*/}
                        {/*<NavLink style={styles.topButton} to={'/login'}>*/}
                            {/*{strings.loginButton}*/}
                        {/*</NavLink>*/}
                    {/*</div>*/}
                    {this.state.forgotPassword?<ForgotPasswordForm/>:<form className="inp" style={styles.authBox} onSubmit={this.submit.bind(this)}>
                        {this.state.errorConnexion?<div className={'errorConnexion'}>{strings.errorConnexion}</div>:null}
                        <label className="inp">
                            <input placeholder="&nbsp;"
                                   id={'inp'}
                                   type="email"
                                   value={this.state.email}
                                   onChange={(e) => this.setState({email: e.target.value})}/>
                            <span className="label">{strings.emailLabel}</span>
                            <span className="border"/>
                        </label>
                        <p style={styles.error}>{rejections.email}</p>

                        <label className="inp">
                            <input placeholder="&nbsp;"
                                   id={'inp'}
                                   type="password"
                                   value={this.state.password}
                                   onChange={(e) => this.setState({password: e.target.value})}/>
                            <span className="label">{strings.passwordLabel}</span>
                            <span className="border"/>
                        </label>
                        <p className={'linkForgotPass'} onClick={()=>{this.setState({forgotPassword:true})}}>{strings.passwordForgot}</p>
                        <p style={styles.error}>{rejections.password}</p>


                        {this.props.fetching ?
                            <PulseLoader color={dk_blue}/>
                            :
                            <button style={styles.validateButton} type={'submit'}>{strings.submitButton}</button>
                        }

                        {/*<NavLink style={styles.forgottenText} to={'/login'}>*/}
                            {/*{strings.forgottenButton}*/}
                        {/*</NavLink>*/}

                        <NavLink style={styles.registerText} to={'/register'}>
                            {strings.registerButton}
                        </NavLink>
                    </form>}
                </div>
            </div>
        );
    }

    async submit(e) {
        e.preventDefault();
        await this.props.login(this.state.email, this.state.password)
        if(this.props.rejectedError==null && this.props.connected){
            this.setState({errorConnexion:false})
            if (this.props.user.isSuperAdmin){
                this.props.history.push('/admin')
            } else {
                this.props.history.push('/')
            }
        } else if(this.props.rejectedError){
            this.setState({errorConnexion:true})
        }
    }
}

const styles = {
    error: {
        color: 'red',
        fontSize: 12,
        marginBottom: 10
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
    },
    authBox: {
        width: 500,
        maxWidth: '80vw',
        backgroundColor: 'white',
        padding: 40,
        paddingTop: 80,
        paddingBottom: 80,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    background: {
        position: 'fixed',
        right: -400,
        bottom: -200,
        zIndex: 0
    },
    logo: {
        position: 'fixed',
        top: 10,
        width: 500,
        maxWidth: '90vw'
    },
    topButtons: {
        display: 'flex',
        backgroundColor: 'white',
        zIndex: 1,
    },
    topButton: {
        flex: 1,
        zIndex: 1,
        height: 60,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white'
    },
    topButtonInactive: {
        flex: 1,
        zIndex: 1,
        height: 60,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        backgroundColor: dk_light_gray
    },
    validateButton: {
        width: '100%',
        maxWidth: 280,
    },
    forgottenText: {
        paddingTop: 20
    },
    registerText: {
        marginTop: 10,
        paddingTop: 10,
        paddingBottom: 10,
        borderColor: dk_blue,
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 10,
        width: '100%',
        maxWidth: 280,
        textAlign: 'center'
    }
}

const mapStateToProps = state => ({
    fetching: fetchingSelector(state),
    rejectedError: rejectedErrorSelector(state),
    connected: connectedSelector(state),
    user: userSelector(state)
})

export default connect(mapStateToProps, {login})(Login);